var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 7.0625H8.9375V0.8125C8.9375 0.639844 8.79766 0.5 8.625 0.5H7.375C7.20234 0.5 7.0625 0.639844 7.0625 0.8125V7.0625H0.8125C0.639844 7.0625 0.5 7.20234 0.5 7.375V8.625C0.5 8.79766 0.639844 8.9375 0.8125 8.9375H7.0625V15.1875C7.0625 15.3602 7.20234 15.5 7.375 15.5H8.625C8.79766 15.5 8.9375 15.3602 8.9375 15.1875V8.9375H15.1875C15.3602 8.9375 15.5 8.79766 15.5 8.625V7.375C15.5 7.20234 15.3602 7.0625 15.1875 7.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.556ec414815e6cb5a36182307be3081b.svg";
export { ForwardRef as ReactComponent };